import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { db } from "../lib/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useTranslation } from "react-i18next";

const WorkWithUsPage = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    profession: "",
    experience: "",
    message: "",
  });

  const [status, setStatus] = useState({ success: false, message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ success: false, message: "" });

    if (!formData.fullName || !formData.email || !formData.phone || !formData.profession || !formData.experience) {
      setStatus({ success: false, message: t("work.status.required") });
      return;
    }

    try {
      await addDoc(collection(db, "workApplications"), {
        ...formData,
        experience: Number(formData.experience),
        appliedAt: serverTimestamp(),
      });

      setStatus({ success: true, message: t("work.status.success") });
      setFormData({ fullName: "", email: "", phone: "", profession: "", experience: "", message: "" });
    } catch (error) {
      console.error("Error submitting application:", error);
      setStatus({ success: false, message: t("work.status.error") });
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <Helmet>
        <title>{t("work.pageTitle")}</title>
        <meta name="description" content={t("work.metaDescription")} />
      </Helmet>

      <h1 className="text-3xl font-bold text-center mb-4">{t("work.heading")}</h1>
      <p className="text-gray-600 mb-6 text-center">{t("work.subheading")}</p>

      <form onSubmit={handleSubmit} className="space-y-4 bg-white shadow-lg p-6 rounded-lg">
        <div>
          <label className="block text-sm font-semibold">{t("work.fields.fullName")}</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder={t("work.placeholders.fullName")}
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">{t("work.fields.email")}</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder={t("work.placeholders.email")}
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">{t("work.fields.phone")}</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder={t("work.placeholders.phone")}
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">{t("work.fields.profession")}</label>
          <select
            name="profession"
            value={formData.profession}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
          >
            <option value="">{t("work.placeholders.profession")}</option>
            <option value="mechanic">{t("work.professions.mechanic")}</option>
            <option value="driver">{t("work.professions.driver")}</option>
            <option value="supplier">{t("work.professions.supplier")}</option>
            <option value="other">{t("work.professions.other")}</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-semibold">{t("work.fields.experience")}</label>
          <input
            type="number"
            name="experience"
            value={formData.experience}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder={t("work.placeholders.experience")}
            min="0"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">{t("work.fields.message")}</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder={t("work.placeholders.message")}
            rows="4"
          ></textarea>
        </div>

        <button type="submit" className="w-full bg-blue-600 text-white font-semibold py-2 rounded hover:bg-blue-700 transition">
          {t("work.submit")}
        </button>

        {status.message && (
          <p className={`text-center mt-2 ${status.success ? "text-green-600" : "text-red-600"}`}>
            {status.message}
          </p>
        )}
      </form>
    </div>
  );
};

export default WorkWithUsPage;
